import { nricFormatRegex } from 'Constants/appointment';
import { isOver16YearsOld } from 'Helpers/utils';
import * as Yup from 'yup';

import { findDigiType } from './helpers';

const requiredField = 'This field is required';

const requiredMsgForGuardian = 'Cannot issue for patient under 16 y/o without a guardian';

export const DigiMCSchema = Yup.object().shape({
  patientNric: Yup.string()
    .trim()
    .required(requiredField)
    .test('nric', requiredMsgForGuardian, value => {
      if (!value || !nricFormatRegex.test(value) || value.trim().charAt(0).toUpperCase() !== 'T')
        return true;

      const yearOfBirth = parseInt(value.trim().substring(1, 3), 10) + 2000;
      return new Date().getFullYear() - yearOfBirth >= 16;
    }),
  patientName: Yup.string().required(requiredField),
  // clinicId: Yup.number().required(requiredField),
  days: Yup.number().required(requiredField),
  digiType: Yup.number().required(requiredField),
  comments: Yup.string().max(255, 'Maximum characters is 255'),
});

export const validateDigi = (values, types, isNeedValidationAge = true) => {
  const errors = {};
  const { fitday, fitFrom, fitTo, digiType, startDate, comments } = values;
  const patientNric = values?.patientNric?.trim();
  // this regex is used to validate the NRIC format
  // this code split to get 2 digits of the year of birth, add 2000 to get the actual year of birth
  // becasuse we only check for nric start with T, so we can assume the year of birth is after 2000
  if (comments.length > 255) {
    errors.comments = 'Maximum characters is 255';
  }
  if (!values.patientName?.trim()) {
    errors.patientName = requiredField;
  }
  if (!values.patientNric?.trim()) {
    errors.patientNric = requiredField;
  } else if (
    isNeedValidationAge &&
    !isOver16YearsOld(patientNric) &&
    nricFormatRegex.test(patientNric) &&
    patientNric?.charAt(0).toUpperCase() === 'T'
  ) {
    errors.patientNric = requiredMsgForGuardian;
  }
  // if (!values.clinicId) {
  //   errors.clinicId = requiredField;
  // }
  if (!values.days) {
    errors.days = requiredField;
  }
  if (!startDate) {
    errors.startDate = requiredField;
  }
  if (!digiType) {
    errors.digiType = requiredField;
  }

  if (fitday) {
    if (!fitFrom) errors.fitFrom = requiredField;
    if (!fitTo) errors.fitTo = requiredField;
  }

  if (digiType) {
    const type = findDigiType(types, digiType);
    const { fields } = type;
    if (fields.length > 0) {
      fields.forEach(({ key }) => {
        if (!values[key]) errors[key] = requiredField;
      });
    }
  }
  return errors;
};
